import {
	LimitRedistributionSchema,
	DTDetailTableSchema,
	LimitDetailTableSchema,
	GuarantorTableSchema,
	HouseOwnerSchema,
	ApplicationCustomersSchema,
	ApplicationCustomerAsHouseOwnerSchema,
	PropertiesSchema,
	LienSchema,
	ApplicationDebtSchema,
	LimitedApplicationDebtSchema,
	LimitedRefinancedApplicationDebtSchema,
	IFormTableSchema
} from "./index";

export const tableSchemas: Record<string, IFormTableSchema<{}>> = {
	ApplicationCustomersSchema: new ApplicationCustomersSchema(),
	ApplicationCustomerAsHouseOwner: new ApplicationCustomerAsHouseOwnerSchema(),
	ApplicationDebtSchema: new ApplicationDebtSchema(),
	DTTableSchema: new DTDetailTableSchema(),
	GuarantorSchema: new GuarantorTableSchema(),
	HouseOwnerSchema: new HouseOwnerSchema(),
	LiensSchema: new LienSchema(),
	LimitDetailSchema: new LimitDetailTableSchema(),
	LimitRedistributionSchema: new LimitRedistributionSchema(),
	LimitedApplicationDebtSchema: new LimitedApplicationDebtSchema(),
	LimitedRefinancedApplicationDebtSchema:
		new LimitedRefinancedApplicationDebtSchema(),
	PropertiesSchema: new PropertiesSchema()
};
